define('models/securecontent/securecontent',['backbone'], function(Backbone){

    var secureContent = Backbone.Model.extend({

        initialize: function (options) {
            options = options || {};
            this.requestBody = options.requestBody;
            this.config = options.config;
        },

        verifySecureAuth: function (callback) {
            callback = callback || {};

            var that = this;

            $.ajax({
                async: false,
                type: 'GET',
                url: pf.authURL + "/Token/CheckFin",
                contentType: "application/json",
                success: function (resp, model) {
                    callback(resp);
                },
                error: function (resp, model) { }
            });

        },

        postContent: function (callback, context) {
            var that = this;
            callback = callback || {};

            var user_guid = pf.session.get('UserGUID');
            // var user_guid = 'b96768ab95a14db19d0fb003b86d36c1';

            this.verifySecureAuth(function(is_secure){

                if(is_secure){

                    var config = that.config || pf.apigconfig.linkCard,
                        apig_client = apigClientFactory.newClient({
                            apiKey: pf.apikey,
                            invokeUrl: config.invokeUrl,
                            endpointPath: config.endpointPath,
                            method: config.method
                        });

                    var params = that.requestBody,
                        body = that.requestBody,
                        additional_params = {
                            headers: {
                                Authorization: user_guid
                            },
                            queryParams: {}
                        };

                    apig_client.makeRequest(params, body, additional_params).then(function(result){

                        if(callback){
                            return callback(null, result, context);
                        } else {
                            return result;
                        }
                        
                    }).catch(function(err){

                            if(callback){
                                return callback(err, context);
                            } else {
                                return err;
                            }

                    });

                }

            });
        }

    });

    return secureContent;
});


